<script>
import AdminLayout from '@layouts/admin-main'
import LangSearch from '@components/admin/lang-search'

export default {
  page: {
    title: 'Admin::LangList',
    meta: [{ name: 'description', content: 'Admin::LangList' }],
  },
  components: { AdminLayout, LangSearch },
}
</script>

<template>
  <AdminLayout>
    <LangSearch></LangSearch>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
